import { TProgressGaugeWidgetModelInputs } from '@monorepo/types';
import * as Highcharts from 'highcharts';
import solidGauge from 'highcharts/modules/solid-gauge';

function getTitleText(label: string, fontSizeMultiplier: number): string {
  return `
        <div style="color: white; text-align: center;">
          <span style="font-size: ${4 * fontSizeMultiplier}vh; font-weight: normal;">${label}</span>
        </div>`;
}

export const PROGRESS_GAUGE_WIDGET_MODEL = {
  createModel: (input?: TProgressGaugeWidgetModelInputs): Highcharts.Options => {
    solidGauge(Highcharts);
    if (!input) return {};
    return {
      chart: {
        type: 'solidgauge',
        backgroundColor: 'transparent',
        height: input.chartSize.type === 'PX' ? input.chartSize.value : `${input.chartSize.value}%`,
        animation: false,
      },
      title: {
        text: getTitleText(input.label, input.fontSizeMultiplier),
        verticalAlign: 'middle',
        align: 'center',
        useHTML: true,
        floating: true,
      },
      pane: {
        startAngle: 0,
        endAngle: 360,
        background: [
          {
            outerRadius: '100%',
            innerRadius: `${input.innerCircleSizeInPercent}%`,
            backgroundColor: input.arcEmptyColor ?? 'black',
            borderWidth: 0,
          },
        ],
      },
      tooltip: {
        enabled: false,
      },
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: [],
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false,
          },
          linecap: 'round',
          stickyTracking: false,
          rounded: input.borderStyle === 'SHARP' ? false : true,
        },
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      series: [
        {
          type: 'solidgauge',
          data: [
            {
              radius: '100%',
              innerRadius: `${input.innerCircleSizeInPercent}%`,
              color: input.arcColor,
              y: input.value,
            },
          ],
        },
      ],
    };
  },
};
